import {sortBy} from 'lodash-es';

export interface MenuItem {
  id: number;
  icon: string;
  link: string;
  seq: number;
  text: string;
  subMenus?: MenuItem[];
  active: boolean;
  roles: string[];
}

export const groupMenu = (menus: any[]): MenuItem[] => {
  const roles = sortBy(menus, 'seq').map(m => {
    if (m.roles) {
      m.roles = (m.roles as any).split(',').map(r => r.trim());
    }
    return m;
  });
  const parents: MenuItem[] = roles.filter(m => !!!m.parent);
  parents.forEach(p => p.subMenus = roles.filter(m => m.parent === p.id));
  return parents;

};

export const filterMenuByRole = (role: string, menus: MenuItem[]): MenuItem[] => {
  menus.forEach(m => {
    m.active = role === 'sys_admin' || m.roles.includes(role);
    if (m.subMenus && m.subMenus.length > 0) {
      filterMenuByRole(role, m.subMenus);
    }
  });
  return menus;
};
